import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Audio } from '../../common';
import { getTrackKey, logSentryCustomEvent } from '../../../utils/functions';

export default function AudioContainer() {
  const [audioTracks, setAudioTracks] = useState([]);

  const participantsJID = useSelector(state => state.conf.participantsJID);
  const isFirstRenderRef = useRef(true);

  const participantsTracks = useSelector(
    state => state.conf.participantsTracks,
  );
  const speaker = useSelector(state => state.conf.speaker);
  const mediaShareparticipantsJID = useSelector(
    state => state.conf.mediaShareparticipantsJID,
  );

  useEffect(() => {
    if (speaker) {
      const allAudioTracks = [];
      Object.keys(participantsJID).forEach(key => {
        let trackKey = getTrackKey(key, 'audio');
        let participantTrack = participantsTracks[trackKey];
        // let audioStatus = participantsJID[key]?.audio;
        if (participantTrack) {
          allAudioTracks.push(participantTrack);
        }else{
     
          // if(audioStatus && !isFirstRenderRef.current){
          //   logSentryCustomEvent('Audio track not found for participant', 'warning', { name: participantsJID[key]?.name, jid: participantsJID[key]?.jid });
          // }
        }
      });
      let mediaTrackKey = getTrackKey(mediaShareparticipantsJID, 'audio');
      let mediaParticipantTrack = participantsTracks[mediaTrackKey];

      if (mediaParticipantTrack) {
        allAudioTracks.push(mediaParticipantTrack);
      }
      setAudioTracks(allAudioTracks);
      isFirstRenderRef.current = false;
    } else {
      setAudioTracks([]);
      isFirstRenderRef.current = false;
    }
  }, [participantsTracks, participantsJID, speaker, mediaShareparticipantsJID]);

  return (
    <div>
      {' '}
      {audioTracks.map(track => {
        const localAudioTrack = track.jitsiTrack;
        let audioTrack = { jitsiTrack: localAudioTrack };
        return (
          <Audio
            key={`audio_${localAudioTrack.getId()}`}
            audioTrack={audioTrack}
            _volume={track.volume}
          />
        );
      })}
    </div>
  );
}
